// extracted by mini-css-extract-plugin
export default {"root":"_1HSDA","link-overlay":"_1wxWE","linkOverlay":"_1wxWE"};